import { AthleteType } from 'utils/player';

import styles from './PlayerInterestsHeader.module.scss';

interface IHeaderProps {
  positionAbbreviation?: string | null;
  playerType?: AthleteType;
}

export const PlayerInterestsHeader = ({
  positionAbbreviation,
  playerType = AthleteType.Star,
}: IHeaderProps) => {
  return (
    <header
      className={styles.block}
      data-interest-type={playerType.toLowerCase()}
      role="row"
    >
      <div className={styles.team}>
        <div id="teams" role="columnheader" title="Team">
          Team
        </div>
        {playerType !== AthleteType.Base && (
          <div id="prediction" role="columnheader" title="Prediction">
            Prediction
          </div>
        )}
        <div id="recruited-by" role="columnheader" title="Recruited By">
          Recruited By
        </div>
      </div>
      <div className={styles.stats}>
        <div id="distance" role="columnheader" title="Distance">
          Distance
        </div>
        <div id="class-rank" role="columnheader" title="Class Rank">
          Class Rank
        </div>
        <div
          id="draft-position"
          role="columnheader"
          title={`${positionAbbreviation} Drafted (5yr)`}
        >
          {positionAbbreviation} Drafted (5yr)
        </div>
        <div id="draft-total" role="columnheader" title="Total Drafted (5yr)">
          Total Drafted (5yr)
        </div>
      </div>
    </header>
  );
};
